<div class="d-flex justify-content-center w-100 position-relative mb-3">
    <img [src]="data.icon">
    <i class="material-icons close-icon-modal" (click)="onCancel()">close</i>
</div> 

<div class="d-flex flex-column justify-content-center w-100">
    <div class="modal-message w-100">
        <p>{{ data.message }}</p>
    </div>
    <div *ngIf="data.reasons?.length" class="w-100 mt-3">
        <mat-form-field class="reason-field" appearance="outline">
            <mat-label>{{ data.reasonLabel || 'Selecione o motivo da exclusão' }}</mat-label>
            <mat-select [(ngModel)]="selectedReason">
                <mat-option *ngFor="let option of data.reasons" [value]="option.value">
                    {{ option.label }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="d-flex flex-row justify-content-between w-100" style="gap: 16px;">
        <button class="btn btn-rounded btn-cancel w-100" style="text-transform: none; font-size: 16px;" (click)="onCancel()">Cancelar</button>
        <button *ngIf="data.color === 'warn'; else confirmPrimary"
                class="btn btn-rounded btn-danger w-100"
                style="text-transform: none; font-size: 16px;"
                [disabled]="requiresReason() && !selectedReason"
                (click)="onConfirm()">{{ data.confirmText }}</button>
        <ng-template #confirmPrimary>
          <button class="btn btn-rounded btn-primary w-100"
                  style="text-transform: none; font-size: 16px;"
                  [disabled]="requiresReason() && !selectedReason"
                  (click)="onConfirm()">{{ data.confirmText }}</button>
        </ng-template>
    </div>
</div>
